export const isOfTypeEnum = <T>(enumType: object, value: string) => {
    return Object.values(enumType).includes(value as T);
};
